import React from 'react';

const ExternalLinkMpsIcon = () => {
  return (
    <svg
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99993 0.25V7.948C10.0004 8.07637 9.95267 8.20024 9.86625 8.29515C9.77982 8.39007 9.66095 8.44914 9.5331 8.46069C9.40525 8.47224 9.27772 8.43545 9.17568 8.35756C9.07364 8.27968 9.0045 8.16637 8.98193 8.04L8.97393 7.948L8.97293 2.122C8.97298 2.11213 8.97012 2.10246 8.96469 2.09422C8.95926 2.08597 8.95152 2.07952 8.94243 2.07567C8.93334 2.07182 8.92331 2.07074 8.91361 2.07258C8.90391 2.07442 8.89497 2.07909 8.88793 2.086L0.875926 10.1C0.791079 10.1852 0.679019 10.2378 0.559307 10.2488C0.439594 10.2598 0.319833 10.2283 0.220926 10.16L0.150926 10.1C0.0657649 10.0152 0.0131057 9.90309 0.00213967 9.78338C-0.00882636 9.66367 0.0225973 9.54391 0.0909258 9.445L0.150926 9.374L8.16093 1.362C8.16812 1.35507 8.17307 1.34613 8.17514 1.33636C8.17721 1.32658 8.17631 1.31641 8.17254 1.30715C8.16877 1.2979 8.16232 1.28998 8.15401 1.28443C8.1457 1.27887 8.13592 1.27594 8.12593 1.276H2.30193C2.18192 1.27612 2.06566 1.23416 1.9734 1.15742C1.88113 1.08068 1.81868 0.974021 1.79693 0.856L1.78893 0.762C1.78893 0.51 1.96993 0.301 2.20893 0.257L2.30293 0.25H9.99993Z"
        fill="#ababab"
      />
    </svg>
  );
};

export default ExternalLinkMpsIcon;
